import { render, staticRenderFns } from "./policy_used.vue?vue&type=template&id=1573cc38&scoped=true"
import script from "./policy_used.vue?vue&type=script&lang=js"
export * from "./policy_used.vue?vue&type=script&lang=js"
import style0 from "./policy_used.vue?vue&type=style&index=0&id=1573cc38&prod&scoped=true&lang=less"
import style1 from "./policy_used.vue?vue&type=style&index=1&id=1573cc38&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1573cc38",
  null
  
)

export default component.exports